import {
  Table,
  TableBody,
  TableRow,
  TableHead,
  TableHeader,
} from "../../../design/table";
import { Subheading } from "../../../design/heading";
import { useEvent } from "../../../contexts/EventContext";
import EmptyStateView from "../../../components/EmptyStateView";
import EventListItem from "../../EventListPage/components/EventList/EventListIItem";
import EventButton from "../../../components/EventButton";

interface EventSubtypesListProps {
  eventCategoryId: string;
}

const EventSubtypesList: React.FC<EventSubtypesListProps> = ({
  eventCategoryId,
}) => {
  const { events } = useEvent();
  const filteredEvents = events.filter(
    (event) => event.eventTypeId === eventCategoryId,
  );
  return (
    <div className="mt-6">
      <div className="flex items-center justify-between">
        <Subheading>Events</Subheading>
        <EventButton date={new Date()} />
      </div>
      {filteredEvents.length === 0 && (
        <EmptyStateView
          title="No Events"
          message="No events found. Create an event to get started."
          action={<EventButton date={new Date()} />}
        />
      )}
      {filteredEvents.length > 0 && (
        <>
          <Table className="mt-8 [--gutter:theme(spacing.6)] lg:[--gutter:theme(spacing.10)]">
            <TableHead>
              <TableRow>
                <TableHeader>Date</TableHeader>
                <TableHeader>People Involved</TableHeader>
                <TableHeader>Category</TableHeader>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredEvents.map((event) => (
                <EventListItem key={event._id} event={event} />
              ))}
            </TableBody>
          </Table>
        </>
      )}
    </div>
  );
};

export default EventSubtypesList;
